window.slate = window.slate || {};
window.theme = $.extend(
  {},
  window.theme,
  { js: { } }
);

/*================ Utils ================*/
theme.Utils = {}

theme.Utils.rem = function () {
  var html = document.getElementsByTagName('html')[0];
  return function () {
    return parseInt(window.getComputedStyle(html)['fontSize']);
  }
}();

//Check if there are any search terms, if terms exist adds a wildcard
theme.Utils.handleSearch = function(e, input) {
  var searchString = input.val()
  if (!searchString) {
    e.preventDefault()
  } else {
    if (searchString.indexOf('*') == -1) {
      searchString = '*' + searchString + '*'
      input.val(searchString)
    }
  }
}

theme.Utils.removeWildCards = function(input) {
  input.val(input.val().replace(/\*/g, ''))
}

theme.Utils.getUrlParam = function(name){
  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
  if (results==null){
   return null;
  }
  else{
   return decodeURI(results[1]) || 0;
  }
}

theme.Utils.updateQueryStringParam = function (key, value) {
    var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
        urlQueryString = document.location.search,
        newParam = key + '=' + value,
        params = '?' + newParam;

    // If the "search" string exists, then build params from it
    if (urlQueryString) {
        keyRegex = new RegExp('([\?&])' + key + '[^&]*');

        // If param exists already, update it
        if (urlQueryString.match(keyRegex) !== null) {
            params = urlQueryString.replace(keyRegex, "$1" + newParam);
        } else { // Otherwise, add it to end of query string
            params = urlQueryString + '&' + newParam;
        }
    }
    window.history.replaceState({}, "", baseUrl + params);
};

theme.Utils.embedResponsively = function ($container) {
  var $iframes = $('iframe', $container)
  if ($iframes.length > 0) {
    $iframes.each(function(){
      $(this).wrap('<div class="youtube-embed"></div>')
    })
  }
}

/**
@description
Toggle/remove/add classes functionality directly in the markup.
Also fires an event for hooks.
@example
<div data-toggle-element='{"togglesClass": "toggled", "allowEscToggle": true}'>Toggle Me</div>
*/

theme.elementToggleClass = function () {

    var s = {
        defaultMethod: "toggle",
        defaultToggles: "html",
        $selector: $("[data-toggle-element]")
    };

    var p, memory = {};

    var addToMemory = function (processedData) {
        memory[processedData.togglesClass] = processedData;
    };

    var removeFromMemory = function (togglesClass) {
        delete memory[togglesClass];
    };

    var getMemory = function () {
        return memory;
    };

    var removeActive = function () {

        $.each(getMemory(), function (key, value) {

            if (value.active && value.allowEscToggle) {
                toggleClass(value);
                triggerToggledEv(value);
            }

        });

    };

    var triggerToggledEv = function (data, evData) {
        evData = {
            hasClass: data.toggles.hasClass(data.togglesClass)
        };
        data.toggles.trigger(data.togglesClass, evData);
    };

    // Data should go through getProcessedData() first.
    var toggleClass = function (processedData) {

        p = processedData;

        if (!p) {
            console.error("Data param missing.");
            return false;
        }

        if (p.method === "toggle") {
            p.toggles.toggleClass(p.togglesClass);

        } else if (p.method === "add") {
            p.toggles.addClass(p.togglesClass);

        } else if (p.method === "remove") {
            p.toggles.removeClass(p.togglesClass);
        }

        p.active = p.toggles.hasClass(p.togglesClass);

        if (p.active) {
            addToMemory(p);
        } else {
            removeFromMemory(p.togglesClass);
        }

    };

    var gatherDataFromEl = function ($el) {
        return $el.data("toggle-element");
    };

    /**
    @description Normalizes the data.
    @param {object} data
    */
    var getProcessedData = function (data) {

        if (!data.togglesClass) {
            console.error("togglesClass key is missing");
            return false;
        }

        if (!data.method) {
            data.method = s.defaultMethod;
        }

        if (!data.allowEscToggle) {
            data.allowEscToggle = false;
        }

        if (!data.toggles) {
            data.toggles = s.defaultToggles;
        }

        if( !$(data.toggles).length ){
            console.warn("Cant find any: " + data.toggles);
            return false;
        }

        // Convert to a jQuery object.
        data.toggles = $(data.toggles);

        return data;

    };

    s.$selector.on("click", function (e) {

        // Stop link default action.
        e.preventDefault();

        var processed, $self, gathered;

        $self = $(this);
        gathered = gatherDataFromEl($self);
        processed = getProcessedData(gathered);

        toggleClass(processed);
        triggerToggledEv(processed);

    });

    $(document).on("keyup", function (e) {

        if (e.which === 27) {
            removeActive();
        }

    });

};

// Select all links with hashes
$('a.is-scroll[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .on('click', function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') ==
        this.pathname.replace(/^\//, '') &&
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash)
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']')
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault()
        scrollTo(target)
      }
    }
  })

// Select all elements with data-scroll-to
$('[data-scroll-to]')
  // Remove links that don't actually link to anything
  .on('click', function(event) {
    // On-page links
    // Figure out element to scroll to
    var hash = $(this).attr('data-scroll-to')
    var target = $(hash)
    target = target.length ? target : $('[name=' + hash.slice(1) + ']')
    // Does a scroll target exist?
    if (target.length) {
      scrollTo(target)
    }
  })

function scrollTo(target) {
  if (target) {
    var isTouch = window.matchMedia('(max-width: 1007px)').matches
    var additional_elements = 0
    if ($('.collection__header').length) {
      additional_elements = parseInt($('.collection__header').css('min-height'), 10)
    }
    var scrollToPos = target.offset().top - (theme.js.header_height_collapsed + additional_elements + 16)
    $('html, body').animate(
      {
        scrollTop: scrollToPos
      },
      1000,
      function() {
        // Callback after animation
        // Must change focus!
        var $target = $(target)
        // $target.focus();
        if ($target.is(':focus')) {
          // Checking if the target was focused
          return false
        } else {
          $target.attr('tabindex', '-1') // Adding tabindex for elements not focusable
          // $target.focus(); // Set focus again
        }
      }
    )
  }
}


/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format, taxable) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    // Add DK taxes
    /*taxable = typeof taxable !== 'undefined' ? taxable : true;
    if (taxable) {
      cents = cents * 1.25      
    }*/

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Boostrap ================*/
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-beta.3): util.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */
var Util = function ($) {
  /**
   * ------------------------------------------------------------------------
   * Private TransitionEnd Helpers
   * ------------------------------------------------------------------------
   */
  var transition = false;
  var MAX_UID = 1000000; // shoutout AngusCroll (https://goo.gl/pxwQGp)

  function toType(obj) {
    return {}.toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
  }

  function getSpecialTransitionEndEvent() {
    return {
      bindType: transition.end,
      delegateType: transition.end,
      handle: function handle(event) {
        if ($(event.target).is(this)) {
          return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
        }

        return undefined; // eslint-disable-line no-undefined
      }
    };
  }

  function transitionEndTest() {
    if (window.QUnit) {
      return false;
    }

    return {
      end: 'transitionend'
    };
  }

  function transitionEndEmulator(duration) {
    var _this = this;

    var called = false;
    $(this).one(Util.TRANSITION_END, function () {
      called = true;
    });
    setTimeout(function () {
      if (!called) {
        Util.triggerTransitionEnd(_this);
      }
    }, duration);
    return this;
  }

  function setTransitionEndSupport() {
    transition = transitionEndTest();
    $.fn.emulateTransitionEnd = transitionEndEmulator;

    if (Util.supportsTransitionEnd()) {
      $.event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
    }
  }

  function escapeId(selector) {
    // we escape IDs in case of special selectors (selector = '#myId:something')
    // $.escapeSelector does not exist in jQuery < 3
    selector = typeof $.escapeSelector === 'function' ? $.escapeSelector(selector).substr(1) : selector.replace(/(:|\.|\[|\]|,|=|@)/g, '\\$1');
    return selector;
  }
  /**
   * --------------------------------------------------------------------------
   * Public Util Api
   * --------------------------------------------------------------------------
   */


  var Util = {
    TRANSITION_END: 'bsTransitionEnd',
    getUID: function getUID(prefix) {
      do {
        // eslint-disable-next-line no-bitwise
        prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
      } while (document.getElementById(prefix));

      return prefix;
    },
    getSelectorFromElement: function getSelectorFromElement(element) {
      var selector = element.getAttribute('data-target');

      if (!selector || selector === '#') {
        selector = element.getAttribute('href') || '';
      } // if it's an ID


      if (selector.charAt(0) === '#') {
        selector = escapeId(selector);
      }

      try {
        var $selector = $(document).find(selector);
        return $selector.length > 0 ? selector : null;
      } catch (error) {
        return null;
      }
    },
    reflow: function reflow(element) {
      return element.offsetHeight;
    },
    triggerTransitionEnd: function triggerTransitionEnd(element) {
      $(element).trigger(transition.end);
    },
    supportsTransitionEnd: function supportsTransitionEnd() {
      return Boolean(transition);
    },
    isElement: function isElement(obj) {
      return (obj[0] || obj).nodeType;
    },
    typeCheckConfig: function typeCheckConfig(componentName, config, configTypes) {
      for (var property in configTypes) {
        if (Object.prototype.hasOwnProperty.call(configTypes, property)) {
          var expectedTypes = configTypes[property];
          var value = config[property];
          var valueType = value && Util.isElement(value) ? 'element' : toType(value);

          if (!new RegExp(expectedTypes).test(valueType)) {
            throw new Error(componentName.toUpperCase() + ": " + ("Option \"" + property + "\" provided type \"" + valueType + "\" ") + ("but expected type \"" + expectedTypes + "\"."));
          }
        }
      }
    }
  };
  setTransitionEndSupport();
  return Util;
}($);
//# sourceMappingURL=util.js.map

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-beta.3): collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */
var Collapse = function ($) {
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */
  var NAME = 'collapse';
  var VERSION = '4.0.0-beta.3';
  var DATA_KEY = 'bs.collapse';
  var EVENT_KEY = "." + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var TRANSITION_DURATION = 600;
  var Default = {
    toggle: true,
    parent: ''
  };
  var DefaultType = {
    toggle: 'boolean',
    parent: '(string|element)'
  };
  var Event = {
    SHOW: "show" + EVENT_KEY,
    SHOWN: "shown" + EVENT_KEY,
    HIDE: "hide" + EVENT_KEY,
    HIDDEN: "hidden" + EVENT_KEY,
    CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
  };
  var ClassName = {
    SHOW: 'show',
    COLLAPSE: 'collapse',
    COLLAPSING: 'collapsing',
    COLLAPSED: 'collapsed'
  };
  var Dimension = {
    WIDTH: 'width',
    HEIGHT: 'height'
  };
  var Selector = {
    ACTIVES: '.show, .collapsing',
    DATA_TOGGLE: '[data-toggle="collapse"]'
    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };

  var Collapse =
  /*#__PURE__*/
  function () {
    function Collapse(element, config) {
      this._isTransitioning = false;
      this._element = element;
      this._config = this._getConfig(config);
      this._triggerArray = $.makeArray($("[data-toggle=\"collapse\"][href=\"#" + element.id + "\"]," + ("[data-toggle=\"collapse\"][data-target=\"#" + element.id + "\"]")));
      var tabToggles = $(Selector.DATA_TOGGLE);

      for (var i = 0; i < tabToggles.length; i++) {
        var elem = tabToggles[i];
        var selector = Util.getSelectorFromElement(elem);

        if (selector !== null && $(selector).filter(element).length > 0) {
          this._triggerArray.push(elem);
        }
      }

      this._parent = this._config.parent ? this._getParent() : null;

      if (!this._config.parent) {
        this._addAriaAndCollapsedClass(this._element, this._triggerArray);
      }

      if (this._config.toggle) {
        this.toggle();
      }
    } // getters


    var _proto = Collapse.prototype;

    // public
    _proto.toggle = function toggle() {
      if ($(this._element).hasClass(ClassName.SHOW)) {
        this.hide();
      } else {
        this.show();
      }
    };

    _proto.show = function show() {
      var _this = this;

      if (this._isTransitioning || $(this._element).hasClass(ClassName.SHOW)) {
        return;
      }

      var actives;
      var activesData;

      if (this._parent) {
        actives = $.makeArray($(this._parent).children().children(Selector.ACTIVES));

        if (!actives.length) {
          actives = null;
        }
      }

      if (actives) {
        activesData = $(actives).data(DATA_KEY);

        if (activesData && activesData._isTransitioning) {
          return;
        }
      }

      var startEvent = $.Event(Event.SHOW);
      $(this._element).trigger(startEvent);

      if (startEvent.isDefaultPrevented()) {
        return;
      }

      if (actives) {
        Collapse._jQueryInterface.call($(actives), 'hide');

        if (!activesData) {
          $(actives).data(DATA_KEY, null);
        }
      }

      var dimension = this._getDimension();

      $(this._element).removeClass(ClassName.COLLAPSE).addClass(ClassName.COLLAPSING);
      this._element.style[dimension] = 0;

      if (this._triggerArray.length) {
        $(this._triggerArray).removeClass(ClassName.COLLAPSED).attr('aria-expanded', true);
      }

      this.setTransitioning(true);

      var complete = function complete() {
        $(_this._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).addClass(ClassName.SHOW);
        _this._element.style[dimension] = '';

        _this.setTransitioning(false);

        $(_this._element).trigger(Event.SHOWN);
      };

      if (!Util.supportsTransitionEnd()) {
        complete();
        return;
      }

      var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
      var scrollSize = "scroll" + capitalizedDimension;
      $(this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
      this._element.style[dimension] = this._element[scrollSize] + "px";
    };

    _proto.hide = function hide() {
      var _this2 = this;

      if (this._isTransitioning || !$(this._element).hasClass(ClassName.SHOW)) {
        return;
      }

      var startEvent = $.Event(Event.HIDE);
      $(this._element).trigger(startEvent);

      if (startEvent.isDefaultPrevented()) {
        return;
      }

      var dimension = this._getDimension();

      this._element.style[dimension] = this._element.getBoundingClientRect()[dimension] + "px";
      Util.reflow(this._element);
      $(this._element).addClass(ClassName.COLLAPSING).removeClass(ClassName.COLLAPSE).removeClass(ClassName.SHOW);

      if (this._triggerArray.length) {
        for (var i = 0; i < this._triggerArray.length; i++) {
          var trigger = this._triggerArray[i];
          var selector = Util.getSelectorFromElement(trigger);

          if (selector !== null) {
            var $elem = $(selector);

            if (!$elem.hasClass(ClassName.SHOW)) {
              $(trigger).addClass(ClassName.COLLAPSED).attr('aria-expanded', false);
            }
          }
        }
      }

      this.setTransitioning(true);

      var complete = function complete() {
        _this2.setTransitioning(false);

        $(_this2._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).trigger(Event.HIDDEN);
      };

      this._element.style[dimension] = '';

      if (!Util.supportsTransitionEnd()) {
        complete();
        return;
      }

      $(this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
    };

    _proto.setTransitioning = function setTransitioning(isTransitioning) {
      this._isTransitioning = isTransitioning;
    };

    _proto.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY);
      this._config = null;
      this._parent = null;
      this._element = null;
      this._triggerArray = null;
      this._isTransitioning = null;
    }; // private


    _proto._getConfig = function _getConfig(config) {
      config = _extends({}, Default, config);
      config.toggle = Boolean(config.toggle); // coerce string values

      Util.typeCheckConfig(NAME, config, DefaultType);
      return config;
    };

    _proto._getDimension = function _getDimension() {
      var hasWidth = $(this._element).hasClass(Dimension.WIDTH);
      return hasWidth ? Dimension.WIDTH : Dimension.HEIGHT;
    };

    _proto._getParent = function _getParent() {
      var _this3 = this;

      var parent = null;

      if (Util.isElement(this._config.parent)) {
        parent = this._config.parent; // it's a jQuery object

        if (typeof this._config.parent.jquery !== 'undefined') {
          parent = this._config.parent[0];
        }
      } else {
        parent = $(this._config.parent)[0];
      }

      var selector = "[data-toggle=\"collapse\"][data-parent=\"" + this._config.parent + "\"]";
      $(parent).find(selector).each(function (i, element) {
        _this3._addAriaAndCollapsedClass(Collapse._getTargetFromElement(element), [element]);
      });
      return parent;
    };

    _proto._addAriaAndCollapsedClass = function _addAriaAndCollapsedClass(element, triggerArray) {
      if (element) {
        var isOpen = $(element).hasClass(ClassName.SHOW);

        if (triggerArray.length) {
          $(triggerArray).toggleClass(ClassName.COLLAPSED, !isOpen).attr('aria-expanded', isOpen);
        }
      }
    }; // static


    Collapse._getTargetFromElement = function _getTargetFromElement(element) {
      var selector = Util.getSelectorFromElement(element);
      return selector ? $(selector)[0] : null;
    };

    Collapse._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $this = $(this);
        var data = $this.data(DATA_KEY);

        var _config = _extends({}, Default, $this.data(), typeof config === 'object' && config);

        if (!data && _config.toggle && /show|hide/.test(config)) {
          _config.toggle = false;
        }

        if (!data) {
          data = new Collapse(this, _config);
          $this.data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new Error("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    _createClass(Collapse, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default;
      }
    }]);

    return Collapse;
  }();
  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */


  $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.currentTarget.tagName === 'A') {
      event.preventDefault();
    }

    var $trigger = $(this);
    var selector = Util.getSelectorFromElement(this);
    $(selector).each(function () {
      var $target = $(this);
      var data = $target.data(DATA_KEY);
      var config = data ? 'toggle' : $trigger.data();

      Collapse._jQueryInterface.call($target, config);
    });
  });
  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Collapse._jQueryInterface;
  $.fn[NAME].Constructor = Collapse;

  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Collapse._jQueryInterface;
  };

  return Collapse;
}($);
//# sourceMappingURL=collapse.js.map

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-beta.3): dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */
var Dropdown = function ($) {
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */
  var NAME = 'dropdown';
  var VERSION = '4.0.0-beta.3';
  var DATA_KEY = 'bs.dropdown';
  var EVENT_KEY = "." + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key

  var SPACE_KEYCODE = 32; // KeyboardEvent.which value for space key

  var TAB_KEYCODE = 9; // KeyboardEvent.which value for tab key

  var ARROW_UP_KEYCODE = 38; // KeyboardEvent.which value for up arrow key

  var ARROW_DOWN_KEYCODE = 40; // KeyboardEvent.which value for down arrow key

  var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming a right-handed mouse)

  var REGEXP_KEYDOWN = new RegExp(ARROW_UP_KEYCODE + "|" + ARROW_DOWN_KEYCODE + "|" + ESCAPE_KEYCODE);
  var Event = {
    HIDE: "hide" + EVENT_KEY,
    HIDDEN: "hidden" + EVENT_KEY,
    SHOW: "show" + EVENT_KEY,
    SHOWN: "shown" + EVENT_KEY,
    CLICK: "click" + EVENT_KEY,
    CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY,
    KEYDOWN_DATA_API: "keydown" + EVENT_KEY + DATA_API_KEY,
    KEYUP_DATA_API: "keyup" + EVENT_KEY + DATA_API_KEY
  };
  var ClassName = {
    DISABLED: 'disabled',
    SHOW: 'show',
    DROPUP: 'dropup',
    DROPRIGHT: 'dropright',
    DROPLEFT: 'dropleft',
    MENURIGHT: 'dropdown-menu-right',
    MENULEFT: 'dropdown-menu-left',
    POSITION_STATIC: 'position-static'
  };
  var Selector = {
    DATA_TOGGLE: '[data-toggle="dropdown"]',
    FORM_CHILD: '.dropdown form',
    MENU: '.dropdown-menu',
    NAVBAR_NAV: '.navbar-nav',
    VISIBLE_ITEMS: '.dropdown-menu .dropdown-item:not(.disabled)'
  };
  var AttachmentMap = {
    TOP: 'top-start',
    TOPEND: 'top-end',
    BOTTOM: 'bottom-start',
    BOTTOMEND: 'bottom-end',
    RIGHT: 'right-start',
    RIGHTEND: 'right-end',
    LEFT: 'left-start',
    LEFTEND: 'left-end'
  };
  var Default = {
    offset: 0,
    flip: true,
    boundary: 'scrollParent'
  };
  var DefaultType = {
    offset: '(number|string|function)',
    flip: 'boolean',
    boundary: '(string|element)'
    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };

  var Dropdown =
  /*#__PURE__*/
  function () {
    function Dropdown(element, config) {
      this._element = element;
      this._popper = null;
      this._config = this._getConfig(config);
      this._menu = this._getMenuElement();
      this._inNavbar = this._detectNavbar();

      this._addEventListeners();
    } // getters


    var _proto = Dropdown.prototype;

    // public
    _proto.toggle = function toggle() {
      if (this._element.disabled || $(this._element).hasClass(ClassName.DISABLED)) {
        return;
      }

      var parent = Dropdown._getParentFromElement(this._element);

      var isActive = $(this._menu).hasClass(ClassName.SHOW);

      Dropdown._clearMenus();

      if (isActive) {
        return;
      }

      var relatedTarget = {
        relatedTarget: this._element
      };
      var showEvent = $.Event(Event.SHOW, relatedTarget);
      $(parent).trigger(showEvent);

      if (showEvent.isDefaultPrevented()) {
        return;
      } // Disable totally Popper.js for Dropdown in Navbar


      if (!this._inNavbar) {
        /**
         * Check for Popper dependency
         * Popper - https://popper.js.org
         */
        if (typeof Popper === 'undefined') {
          throw new Error('Bootstrap dropdown require Popper.js (https://popper.js.org)');
        }

        var element = this._element; // for dropup with alignment we use the parent as popper container

        if ($(parent).hasClass(ClassName.DROPUP)) {
          if ($(this._menu).hasClass(ClassName.MENULEFT) || $(this._menu).hasClass(ClassName.MENURIGHT)) {
            element = parent;
          }
        } // If boundary is not `scrollParent`, then set position to `static`
        // to allow the menu to "escape" the scroll parent's boundaries
        // https://github.com/twbs/bootstrap/issues/24251


        if (this._config.boundary !== 'scrollParent') {
          $(parent).addClass(ClassName.POSITION_STATIC);
        }

        this._popper = new Popper(element, this._menu, this._getPopperConfig());
      } // if this is a touch-enabled device we add extra
      // empty mouseover listeners to the body's immediate children;
      // only needed because of broken event delegation on iOS
      // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html


      if ('ontouchstart' in document.documentElement && !$(parent).closest(Selector.NAVBAR_NAV).length) {
        $('body').children().on('mouseover', null, $.noop);
      }

      this._element.focus();

      this._element.setAttribute('aria-expanded', true);

      $(this._menu).toggleClass(ClassName.SHOW);
      $(parent).toggleClass(ClassName.SHOW).trigger($.Event(Event.SHOWN, relatedTarget));
    };

    _proto.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY);
      $(this._element).off(EVENT_KEY);
      this._element = null;
      this._menu = null;

      if (this._popper !== null) {
        this._popper.destroy();

        this._popper = null;
      }
    };

    _proto.update = function update() {
      this._inNavbar = this._detectNavbar();

      if (this._popper !== null) {
        this._popper.scheduleUpdate();
      }
    }; // private


    _proto._addEventListeners = function _addEventListeners() {
      var _this = this;

      $(this._element).on(Event.CLICK, function (event) {
        event.preventDefault();
        event.stopPropagation();

        _this.toggle();
      });
    };

    _proto._getConfig = function _getConfig(config) {
      config = _extends({}, this.constructor.Default, $(this._element).data(), config);
      Util.typeCheckConfig(NAME, config, this.constructor.DefaultType);
      return config;
    };

    _proto._getMenuElement = function _getMenuElement() {
      if (!this._menu) {
        var parent = Dropdown._getParentFromElement(this._element);

        this._menu = $(parent).find(Selector.MENU)[0];
      }

      return this._menu;
    };

    _proto._getPlacement = function _getPlacement() {
      var $parentDropdown = $(this._element).parent();
      var placement = AttachmentMap.BOTTOM; // Handle dropup

      if ($parentDropdown.hasClass(ClassName.DROPUP)) {
        placement = AttachmentMap.TOP;

        if ($(this._menu).hasClass(ClassName.MENURIGHT)) {
          placement = AttachmentMap.TOPEND;
        }
      } else if ($parentDropdown.hasClass(ClassName.DROPRIGHT)) {
        placement = AttachmentMap.RIGHT;
      } else if ($parentDropdown.hasClass(ClassName.DROPLEFT)) {
        placement = AttachmentMap.LEFT;
      } else if ($(this._menu).hasClass(ClassName.MENURIGHT)) {
        placement = AttachmentMap.BOTTOMEND;
      }

      return placement;
    };

    _proto._detectNavbar = function _detectNavbar() {
      return $(this._element).closest('.navbar').length > 0;
    };

    _proto._getPopperConfig = function _getPopperConfig() {
      var _this2 = this;

      var offsetConf = {};

      if (typeof this._config.offset === 'function') {
        offsetConf.fn = function (data) {
          data.offsets = _extends({}, data.offsets, _this2._config.offset(data.offsets) || {});
          return data;
        };
      } else {
        offsetConf.offset = this._config.offset;
      }

      var popperConfig = {
        placement: this._getPlacement(),
        modifiers: {
          offset: offsetConf,
          flip: {
            enabled: this._config.flip
          },
          preventOverflow: {
            boundariesElement: this._config.boundary
          }
        }
      };
      return popperConfig;
    }; // static


    Dropdown._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        var _config = typeof config === 'object' ? config : null;

        if (!data) {
          data = new Dropdown(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new Error("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    Dropdown._clearMenus = function _clearMenus(event) {
      if (event && (event.which === RIGHT_MOUSE_BUTTON_WHICH || event.type === 'keyup' && event.which !== TAB_KEYCODE)) {
        return;
      }

      var toggles = $.makeArray($(Selector.DATA_TOGGLE));

      for (var i = 0; i < toggles.length; i++) {
        var parent = Dropdown._getParentFromElement(toggles[i]);

        var context = $(toggles[i]).data(DATA_KEY);
        var relatedTarget = {
          relatedTarget: toggles[i]
        };

        if (!context) {
          continue;
        }

        var dropdownMenu = context._menu;

        if (!$(parent).hasClass(ClassName.SHOW)) {
          continue;
        }

        if (event && (event.type === 'click' && /input|textarea/i.test(event.target.tagName) || event.type === 'keyup' && event.which === TAB_KEYCODE) && $.contains(parent, event.target)) {
          continue;
        }

        var hideEvent = $.Event(Event.HIDE, relatedTarget);
        $(parent).trigger(hideEvent);

        if (hideEvent.isDefaultPrevented()) {
          continue;
        } // if this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support


        if ('ontouchstart' in document.documentElement) {
          $('body').children().off('mouseover', null, $.noop);
        }

        toggles[i].setAttribute('aria-expanded', 'false');
        $(dropdownMenu).removeClass(ClassName.SHOW);
        $(parent).removeClass(ClassName.SHOW).trigger($.Event(Event.HIDDEN, relatedTarget));
      }
    };

    Dropdown._getParentFromElement = function _getParentFromElement(element) {
      var parent;
      var selector = Util.getSelectorFromElement(element);

      if (selector) {
        parent = $(selector)[0];
      }

      return parent || element.parentNode;
    };

    Dropdown._dataApiKeydownHandler = function _dataApiKeydownHandler(event) {
      // If not input/textarea:
      //  - And not a key in REGEXP_KEYDOWN => not a dropdown command
      // If input/textarea:
      //  - If space key => not a dropdown command
      //  - If key is other than escape
      //    - If key is not up or down => not a dropdown command
      //    - If trigger inside the menu => not a dropdown command
      if (/input|textarea/i.test(event.target.tagName) ? event.which === SPACE_KEYCODE || event.which !== ESCAPE_KEYCODE && (event.which !== ARROW_DOWN_KEYCODE && event.which !== ARROW_UP_KEYCODE || $(event.target).closest(Selector.MENU).length) : !REGEXP_KEYDOWN.test(event.which)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (this.disabled || $(this).hasClass(ClassName.DISABLED)) {
        return;
      }

      var parent = Dropdown._getParentFromElement(this);

      var isActive = $(parent).hasClass(ClassName.SHOW);

      if (!isActive && (event.which !== ESCAPE_KEYCODE || event.which !== SPACE_KEYCODE) || isActive && (event.which === ESCAPE_KEYCODE || event.which === SPACE_KEYCODE)) {
        if (event.which === ESCAPE_KEYCODE) {
          var toggle = $(parent).find(Selector.DATA_TOGGLE)[0];
          $(toggle).trigger('focus');
        }

        $(this).trigger('click');
        return;
      }

      var items = $(parent).find(Selector.VISIBLE_ITEMS).get();

      if (!items.length) {
        return;
      }

      var index = items.indexOf(event.target);

      if (event.which === ARROW_UP_KEYCODE && index > 0) {
        // up
        index--;
      }

      if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) {
        // down
        index++;
      }

      if (index < 0) {
        index = 0;
      }

      items[index].focus();
    };

    _createClass(Dropdown, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default;
      }
    }, {
      key: "DefaultType",
      get: function get() {
        return DefaultType;
      }
    }]);

    return Dropdown;
  }();
  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */


  $(document).on(Event.KEYDOWN_DATA_API, Selector.DATA_TOGGLE, Dropdown._dataApiKeydownHandler).on(Event.KEYDOWN_DATA_API, Selector.MENU, Dropdown._dataApiKeydownHandler).on(Event.CLICK_DATA_API + " " + Event.KEYUP_DATA_API, Dropdown._clearMenus).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
    event.preventDefault();
    event.stopPropagation();

    Dropdown._jQueryInterface.call($(this), 'toggle');
  }).on(Event.CLICK_DATA_API, Selector.FORM_CHILD, function (e) {
    e.stopPropagation();
  });
  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Dropdown._jQueryInterface;
  $.fn[NAME].Constructor = Dropdown;

  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Dropdown._jQueryInterface;
  };

  return Dropdown;
}($, Popper);
//# sourceMappingURL=dropdown.js.map

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-beta.3): scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */
var ScrollSpy = function ($) {
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */
  var NAME = 'scrollspy';
  var VERSION = '4.0.0-beta.3';
  var DATA_KEY = 'bs.scrollspy';
  var EVENT_KEY = "." + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var Default = {
    offset: 10,
    method: 'auto',
    target: ''
  };
  var DefaultType = {
    offset: 'number',
    method: 'string',
    target: '(string|element)'
  };
  var Event = {
    ACTIVATE: "activate" + EVENT_KEY,
    SCROLL: "scroll" + EVENT_KEY,
    LOAD_DATA_API: "load" + EVENT_KEY + DATA_API_KEY
  };
  var ClassName = {
    DROPDOWN_ITEM: 'dropdown-item',
    DROPDOWN_MENU: 'dropdown-menu',
    ACTIVE: 'active'
  };
  var Selector = {
    DATA_SPY: '[data-spy="scroll"]',
    ACTIVE: '.active',
    NAV_LIST_GROUP: '.nav, .list-group',
    NAV_LINKS: '.nav-link',
    NAV_ITEMS: '.nav-item',
    LIST_ITEMS: '.list-group-item',
    DROPDOWN: '.dropdown',
    DROPDOWN_ITEMS: '.dropdown-item',
    DROPDOWN_TOGGLE: '.dropdown-toggle'
  };
  var OffsetMethod = {
    OFFSET: 'offset',
    POSITION: 'position'
    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };

  var ScrollSpy =
  /*#__PURE__*/
  function () {
    function ScrollSpy(element, config) {
      var _this = this;

      this._element = element;
      this._scrollElement = element.tagName === 'BODY' ? window : element;
      this._config = this._getConfig(config);
      this._selector = this._config.target + " " + Selector.NAV_LINKS + "," + (this._config.target + " " + Selector.LIST_ITEMS + ",") + (this._config.target + " " + Selector.DROPDOWN_ITEMS);
      this._offsets = [];
      this._targets = [];
      this._activeTarget = null;
      this._scrollHeight = 0;
      $(this._scrollElement).on(Event.SCROLL, function (event) {
        return _this._process(event);
      });
      this.refresh();

      this._process();
    } // getters


    var _proto = ScrollSpy.prototype;

    // public
    _proto.refresh = function refresh() {
      var _this2 = this;

      var autoMethod = this._scrollElement !== this._scrollElement.window ? OffsetMethod.POSITION : OffsetMethod.OFFSET;
      var offsetMethod = this._config.method === 'auto' ? autoMethod : this._config.method;
      var offsetBase = offsetMethod === OffsetMethod.POSITION ? this._getScrollTop() : 0;
      this._offsets = [];
      this._targets = [];
      this._scrollHeight = this._getScrollHeight();
      var targets = $.makeArray($(this._selector));
      targets.map(function (element) {
        var target;
        var targetSelector = Util.getSelectorFromElement(element);

        if (targetSelector) {
          target = $(targetSelector)[0];
        }

        if (target) {
          var targetBCR = target.getBoundingClientRect();

          if (targetBCR.width || targetBCR.height) {
            // todo (fat): remove sketch reliance on jQuery position/offset
            return [$(target)[offsetMethod]().top + offsetBase, targetSelector];
          }
        }

        return null;
      }).filter(function (item) {
        return item;
      }).sort(function (a, b) {
        return a[0] - b[0];
      }).forEach(function (item) {
        _this2._offsets.push(item[0]);

        _this2._targets.push(item[1]);
      });
    };

    _proto.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY);
      $(this._scrollElement).off(EVENT_KEY);
      this._element = null;
      this._scrollElement = null;
      this._config = null;
      this._selector = null;
      this._offsets = null;
      this._targets = null;
      this._activeTarget = null;
      this._scrollHeight = null;
    }; // private


    _proto._getConfig = function _getConfig(config) {
      config = _extends({}, Default, config);

      if (typeof config.target !== 'string') {
        var id = $(config.target).attr('id');

        if (!id) {
          id = Util.getUID(NAME);
          $(config.target).attr('id', id);
        }

        config.target = "#" + id;
      }

      Util.typeCheckConfig(NAME, config, DefaultType);
      return config;
    };

    _proto._getScrollTop = function _getScrollTop() {
      return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
    };

    _proto._getScrollHeight = function _getScrollHeight() {
      return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
    };

    _proto._getOffsetHeight = function _getOffsetHeight() {
      return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
    };

    _proto._process = function _process() {
      var scrollTop = this._getScrollTop() + this._config.offset;

      var scrollHeight = this._getScrollHeight();

      var maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();

      if (this._scrollHeight !== scrollHeight) {
        this.refresh();
      }

      if (scrollTop >= maxScroll) {
        var target = this._targets[this._targets.length - 1];

        if (this._activeTarget !== target) {
          this._activate(target);
        }

        return;
      }

      if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
        this._activeTarget = null;

        this._clear();

        return;
      }

      for (var i = this._offsets.length; i--;) {
        var isActiveTarget = this._activeTarget !== this._targets[i] && scrollTop >= this._offsets[i] && (typeof this._offsets[i + 1] === 'undefined' || scrollTop < this._offsets[i + 1]);

        if (isActiveTarget) {
          this._activate(this._targets[i]);
        }
      }
    };

    _proto._activate = function _activate(target) {
      this._activeTarget = target;

      this._clear();

      var queries = this._selector.split(','); // eslint-disable-next-line arrow-body-style


      queries = queries.map(function (selector) {
        return selector + "[data-target=\"" + target + "\"]," + (selector + "[href=\"" + target + "\"]");
      });
      var $link = $(queries.join(','));

      if ($link.hasClass(ClassName.DROPDOWN_ITEM)) {
        $link.closest(Selector.DROPDOWN).find(Selector.DROPDOWN_TOGGLE).addClass(ClassName.ACTIVE);
        $link.addClass(ClassName.ACTIVE);
      } else {
        // Set triggered link as active
        $link.addClass(ClassName.ACTIVE); // Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor

        $link.parents(Selector.NAV_LIST_GROUP).prev(Selector.NAV_LINKS + ", " + Selector.LIST_ITEMS).addClass(ClassName.ACTIVE); // Handle special case when .nav-link is inside .nav-item

        $link.parents(Selector.NAV_LIST_GROUP).prev(Selector.NAV_ITEMS).children(Selector.NAV_LINKS).addClass(ClassName.ACTIVE);
      }

      $(this._scrollElement).trigger(Event.ACTIVATE, {
        relatedTarget: target
      });
    };

    _proto._clear = function _clear() {
      $(this._selector).filter(Selector.ACTIVE).removeClass(ClassName.ACTIVE);
    }; // static


    ScrollSpy._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        var _config = typeof config === 'object' && config;

        if (!data) {
          data = new ScrollSpy(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new Error("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    _createClass(ScrollSpy, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default;
      }
    }]);

    return ScrollSpy;
  }();
  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */


  $(window).on(Event.LOAD_DATA_API, function () {
    var scrollSpys = $.makeArray($(Selector.DATA_SPY));

    for (var i = scrollSpys.length; i--;) {
      var $spy = $(scrollSpys[i]);

      ScrollSpy._jQueryInterface.call($spy, $spy.data());
    }
  });
  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = ScrollSpy._jQueryInterface;
  $.fn[NAME].Constructor = ScrollSpy;

  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return ScrollSpy._jQueryInterface;
  };

  return ScrollSpy;
}($);
//# sourceMappingURL=scrollspy.js.map

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-beta.3): modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */
var Modal = function ($) {
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */
  var NAME = 'modal';
  var VERSION = '4.0.0-beta.3';
  var DATA_KEY = 'bs.modal';
  var EVENT_KEY = "." + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];
  var TRANSITION_DURATION = 300;
  var BACKDROP_TRANSITION_DURATION = 150;
  var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key

  var Default = {
    backdrop: true,
    keyboard: true,
    focus: true,
    show: true
  };
  var DefaultType = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    focus: 'boolean',
    show: 'boolean'
  };
  var Event = {
    HIDE: "hide" + EVENT_KEY,
    HIDDEN: "hidden" + EVENT_KEY,
    SHOW: "show" + EVENT_KEY,
    SHOWN: "shown" + EVENT_KEY,
    FOCUSIN: "focusin" + EVENT_KEY,
    RESIZE: "resize" + EVENT_KEY,
    CLICK_DISMISS: "click.dismiss" + EVENT_KEY,
    KEYDOWN_DISMISS: "keydown.dismiss" + EVENT_KEY,
    MOUSEUP_DISMISS: "mouseup.dismiss" + EVENT_KEY,
    MOUSEDOWN_DISMISS: "mousedown.dismiss" + EVENT_KEY,
    CLICK_DATA_API: "click" + EVENT_KEY + DATA_API_KEY
  };
  var ClassName = {
    SCROLLBAR_MEASURER: 'modal-scrollbar-measure',
    BACKDROP: 'modal-backdrop',
    OPEN: 'modal-open',
    FADE: 'fade',
    SHOW: 'show'
  };
  var Selector = {
    DIALOG: '.modal-dialog',
    DATA_TOGGLE: '[data-toggle="modal"]',
    DATA_DISMISS: '[data-dismiss="modal"]',
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */

  };

  var Modal =
  /*#__PURE__*/
  function () {
    function Modal(element, config) {
      this._config = this._getConfig(config);
      this._element = element;
      this._dialog = $(element).find(Selector.DIALOG)[0];
      this._backdrop = null;
      this._isShown = false;
      this._isBodyOverflowing = false;
      this._ignoreBackdropClick = false;
      this._originalBodyPadding = 0;
      this._scrollbarWidth = 0;
    } // getters


    var _proto = Modal.prototype;

    // public
    _proto.toggle = function toggle(relatedTarget) {
      return this._isShown ? this.hide() : this.show(relatedTarget);
    };

    _proto.show = function show(relatedTarget) {
      var _this = this;

      if (this._isTransitioning || this._isShown) {
        return;
      }

      if (Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE)) {
        this._isTransitioning = true;
      }

      var showEvent = $.Event(Event.SHOW, {
        relatedTarget: relatedTarget
      });
      $(this._element).trigger(showEvent);

      if (this._isShown || showEvent.isDefaultPrevented()) {
        return;
      }

      this._isShown = true;

      this._checkScrollbar();

      this._setScrollbar();

      this._adjustDialog();

      $(document.body).addClass(ClassName.OPEN);

      this._setEscapeEvent();

      this._setResizeEvent();

      $(this._element).on(Event.CLICK_DISMISS, Selector.DATA_DISMISS, function (event) {
        return _this.hide(event);
      });
      $(this._dialog).on(Event.MOUSEDOWN_DISMISS, function () {
        $(_this._element).one(Event.MOUSEUP_DISMISS, function (event) {
          if ($(event.target).is(_this._element)) {
            _this._ignoreBackdropClick = true;
          }
        });
      });

      this._showBackdrop(function () {
        return _this._showElement(relatedTarget);
      });
    };

    _proto.hide = function hide(event) {
      var _this2 = this;

      if (event) {
        event.preventDefault();
      }

      if (this._isTransitioning || !this._isShown) {
        return;
      }

      var hideEvent = $.Event(Event.HIDE);
      $(this._element).trigger(hideEvent);

      if (!this._isShown || hideEvent.isDefaultPrevented()) {
        return;
      }

      this._isShown = false;
      var transition = Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE);

      if (transition) {
        this._isTransitioning = true;
      }

      this._setEscapeEvent();

      this._setResizeEvent();

      $(document).off(Event.FOCUSIN);
      $(this._element).removeClass(ClassName.SHOW);
      $(this._element).off(Event.CLICK_DISMISS);
      $(this._dialog).off(Event.MOUSEDOWN_DISMISS);

      if (transition) {
        $(this._element).one(Util.TRANSITION_END, function (event) {
          return _this2._hideModal(event);
        }).emulateTransitionEnd(TRANSITION_DURATION);
      } else {
        this._hideModal();
      }
    };

    _proto.dispose = function dispose() {
      $.removeData(this._element, DATA_KEY);
      $(window, document, this._element, this._backdrop).off(EVENT_KEY);
      this._config = null;
      this._element = null;
      this._dialog = null;
      this._backdrop = null;
      this._isShown = null;
      this._isBodyOverflowing = null;
      this._ignoreBackdropClick = null;
      this._scrollbarWidth = null;
    };

    _proto.handleUpdate = function handleUpdate() {
      this._adjustDialog();
    }; // private


    _proto._getConfig = function _getConfig(config) {
      config = _extends({}, Default, config);
      Util.typeCheckConfig(NAME, config, DefaultType);
      return config;
    };

    _proto._showElement = function _showElement(relatedTarget) {
      var _this3 = this;

      var transition = Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE);

      if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) {
        // don't move modals dom position
        document.body.appendChild(this._element);
      }

      this._element.style.display = 'block';

      this._element.removeAttribute('aria-hidden');

      this._element.scrollTop = 0;

      if (transition) {
        Util.reflow(this._element);
      }

      $(this._element).addClass(ClassName.SHOW);

      if (this._config.focus) {
        this._enforceFocus();
      }

      var shownEvent = $.Event(Event.SHOWN, {
        relatedTarget: relatedTarget
      });

      var transitionComplete = function transitionComplete() {
        if (_this3._config.focus) {
          _this3._element.focus();
        }

        _this3._isTransitioning = false;
        $(_this3._element).trigger(shownEvent);
      };

      if (transition) {
        $(this._dialog).one(Util.TRANSITION_END, transitionComplete).emulateTransitionEnd(TRANSITION_DURATION);
      } else {
        transitionComplete();
      }
    };

    _proto._enforceFocus = function _enforceFocus() {
      var _this4 = this;

      $(document).off(Event.FOCUSIN) // guard against infinite focus loop
      .on(Event.FOCUSIN, function (event) {
        if (document !== event.target && _this4._element !== event.target && !$(_this4._element).has(event.target).length) {
          _this4._element.focus();
        }
      });
    };

    _proto._setEscapeEvent = function _setEscapeEvent() {
      var _this5 = this;

      if (this._isShown && this._config.keyboard) {
        $(this._element).on(Event.KEYDOWN_DISMISS, function (event) {
          if (event.which === ESCAPE_KEYCODE) {
            event.preventDefault();

            _this5.hide();
          }
        });
      } else if (!this._isShown) {
        $(this._element).off(Event.KEYDOWN_DISMISS);
      }
    };

    _proto._setResizeEvent = function _setResizeEvent() {
      var _this6 = this;

      if (this._isShown) {
        $(window).on(Event.RESIZE, function (event) {
          return _this6.handleUpdate(event);
        });
      } else {
        $(window).off(Event.RESIZE);
      }
    };

    _proto._hideModal = function _hideModal() {
      var _this7 = this;

      this._element.style.display = 'none';

      this._element.setAttribute('aria-hidden', true);

      this._isTransitioning = false;

      this._showBackdrop(function () {
        $(document.body).removeClass(ClassName.OPEN);

        _this7._resetAdjustments();

        _this7._resetScrollbar();

        $(_this7._element).trigger(Event.HIDDEN);
      });
    };

    _proto._removeBackdrop = function _removeBackdrop() {
      if (this._backdrop) {
        $(this._backdrop).remove();
        this._backdrop = null;
      }
    };

    _proto._showBackdrop = function _showBackdrop(callback) {
      var _this8 = this;

      var animate = $(this._element).hasClass(ClassName.FADE) ? ClassName.FADE : '';

      if (this._isShown && this._config.backdrop) {
        var doAnimate = Util.supportsTransitionEnd() && animate;
        this._backdrop = document.createElement('div');
        this._backdrop.className = ClassName.BACKDROP;

        if (animate) {
          $(this._backdrop).addClass(animate);
        }

        $(this._backdrop).appendTo(document.body);
        $(this._element).on(Event.CLICK_DISMISS, function (event) {
          if (_this8._ignoreBackdropClick) {
            _this8._ignoreBackdropClick = false;
            return;
          }

          if (event.target !== event.currentTarget) {
            return;
          }

          if (_this8._config.backdrop === 'static') {
            _this8._element.focus();
          } else {
            _this8.hide();
          }
        });

        if (doAnimate) {
          Util.reflow(this._backdrop);
        }

        $(this._backdrop).addClass(ClassName.SHOW);

        if (!callback) {
          return;
        }

        if (!doAnimate) {
          callback();
          return;
        }

        $(this._backdrop).one(Util.TRANSITION_END, callback).emulateTransitionEnd(BACKDROP_TRANSITION_DURATION);
      } else if (!this._isShown && this._backdrop) {
        $(this._backdrop).removeClass(ClassName.SHOW);

        var callbackRemove = function callbackRemove() {
          _this8._removeBackdrop();

          if (callback) {
            callback();
          }
        };

        if (Util.supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE)) {
          $(this._backdrop).one(Util.TRANSITION_END, callbackRemove).emulateTransitionEnd(BACKDROP_TRANSITION_DURATION);
        } else {
          callbackRemove();
        }
      } else if (callback) {
        callback();
      }
    }; // ----------------------------------------------------------------------
    // the following methods are used to handle overflowing modals
    // todo (fat): these should probably be refactored out of modal.js
    // ----------------------------------------------------------------------


    _proto._adjustDialog = function _adjustDialog() {
      var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;

      if (!this._isBodyOverflowing && isModalOverflowing) {
        this._element.style.paddingLeft = this._scrollbarWidth + "px";
      }

      if (this._isBodyOverflowing && !isModalOverflowing) {
        this._element.style.paddingRight = this._scrollbarWidth + "px";
      }
    };

    _proto._resetAdjustments = function _resetAdjustments() {
      this._element.style.paddingLeft = '';
      this._element.style.paddingRight = '';
    };

    _proto._checkScrollbar = function _checkScrollbar() {
      var rect = document.body.getBoundingClientRect();
      this._isBodyOverflowing = rect.left + rect.right < window.innerWidth;
      this._scrollbarWidth = this._getScrollbarWidth();
    };

    _proto._setScrollbar = function _setScrollbar() {
      var _this9 = this;

      if (this._isBodyOverflowing) {
        // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
        //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
        // Adjust fixed content padding
        $(Selector.FIXED_CONTENT).each(function (index, element) {
          var actualPadding = $(element)[0].style.paddingRight;
          var calculatedPadding = $(element).css('padding-right');
          $(element).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + _this9._scrollbarWidth + "px");
        }); // Adjust sticky content margin

        $(Selector.STICKY_CONTENT).each(function (index, element) {
          var actualMargin = $(element)[0].style.marginRight;
          var calculatedMargin = $(element).css('margin-right');
          $(element).data('margin-right', actualMargin).css('margin-right', parseFloat(calculatedMargin) - _this9._scrollbarWidth + "px");
        }); // Adjust navbar-toggler margin

        $(Selector.NAVBAR_TOGGLER).each(function (index, element) {
          var actualMargin = $(element)[0].style.marginRight;
          var calculatedMargin = $(element).css('margin-right');
          $(element).data('margin-right', actualMargin).css('margin-right', parseFloat(calculatedMargin) + _this9._scrollbarWidth + "px");
        }); // Adjust body padding

        var actualPadding = document.body.style.paddingRight;
        var calculatedPadding = $('body').css('padding-right');
        $('body').data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + this._scrollbarWidth + "px");
      }
    };

    _proto._resetScrollbar = function _resetScrollbar() {
      // Restore fixed content padding
      $(Selector.FIXED_CONTENT).each(function (index, element) {
        var padding = $(element).data('padding-right');

        if (typeof padding !== 'undefined') {
          $(element).css('padding-right', padding).removeData('padding-right');
        }
      }); // Restore sticky content and navbar-toggler margin

      $(Selector.STICKY_CONTENT + ", " + Selector.NAVBAR_TOGGLER).each(function (index, element) {
        var margin = $(element).data('margin-right');

        if (typeof margin !== 'undefined') {
          $(element).css('margin-right', margin).removeData('margin-right');
        }
      }); // Restore body padding

      var padding = $('body').data('padding-right');

      if (typeof padding !== 'undefined') {
        $('body').css('padding-right', padding).removeData('padding-right');
      }
    };

    _proto._getScrollbarWidth = function _getScrollbarWidth() {
      // thx d.walsh
      var scrollDiv = document.createElement('div');
      scrollDiv.className = ClassName.SCROLLBAR_MEASURER;
      document.body.appendChild(scrollDiv);
      var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
      return scrollbarWidth;
    }; // static


    Modal._jQueryInterface = function _jQueryInterface(config, relatedTarget) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        var _config = _extends({}, Modal.Default, $(this).data(), typeof config === 'object' && config);

        if (!data) {
          data = new Modal(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new Error("No method named \"" + config + "\"");
          }

          data[config](relatedTarget);
        } else if (_config.show) {
          data.show(relatedTarget);
        }
      });
    };

    _createClass(Modal, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default;
      }
    }]);

    return Modal;
  }();
  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */


  $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
    var _this10 = this;

    var target;
    var selector = Util.getSelectorFromElement(this);

    if (selector) {
      target = $(selector)[0];
    }

    var config = $(target).data(DATA_KEY) ? 'toggle' : _extends({}, $(target).data(), $(this).data());

    if (this.tagName === 'A' || this.tagName === 'AREA') {
      event.preventDefault();
    }

    var $target = $(target).one(Event.SHOW, function (showEvent) {
      if (showEvent.isDefaultPrevented()) {
        // only register focus restorer if modal will actually get shown
        return;
      }

      $target.one(Event.HIDDEN, function () {
        if ($(_this10).is(':visible')) {
          _this10.focus();
        }
      });
    });

    Modal._jQueryInterface.call($(target), config, this);
  });
  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Modal._jQueryInterface;
  $.fn[NAME].Constructor = Modal;

  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Modal._jQueryInterface;
  };

  return Modal;
}($);
//# sourceMappingURL=modal.js.map


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePercent: '[data-compare-percent]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    stock: '[data-stock]',
    cartForm: '[data-cart-form]',
    cartError: '[data-cart-error]',
    quantitySelect: '[data-quantity-select]',
    collectionVariantSelect: '[data-collection-variant-select]',
    foilWidth: '[data-foil-width]',
    spareparts: '[data-spareparts]',
    sparepartsJSON: '[data-spareparts-json]',
  };

  var data = {
    hasQuantity: 'data-has-quantity',
    hasCollectionVariants: 'data-has-collection-variants',
    collectionVariantType: 'data-collection-variant-select',
    productCollection: 'data-product-collection',
    foilWidth: 'data-foil-width',
    isSparepartGroup: 'data-is-sparepart-group',
    sparepartVariantID: 'data-sparepart-variant-id',
  }

  var classNames = {
    addToCartSoldOut: 'btn-danger',
    addToCartAvailable: 'btn-primary',
    inStock: 'text-success',
    outOfStock: 'text-danger'
  }

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);
    this.$cartForm =  $(selectors.cartForm, this.$container)
    this.$cartError =  $(selectors.cartError, this.$container)
    this.$addToCart =  $(selectors.addToCart, this.$container)
    this.hasQuantity =  $(this.$container).attr(data.hasQuantity)
    this.$quantitySelect =  $(selectors.quantitySelect, this.$container)
    this.hasCollectionVariants =  $(this.$container).attr(data.hasCollectionVariants)
    this.$collectionVariantSelect =  $(selectors.collectionVariantSelect, this.$container)
    this.collectionVariantType = this.$collectionVariantSelect.attr(data.collectionVariantType)
    this.productCollection = $(this.$container).attr(data.productCollection)

    this.$foilWidth = $(selectors.foilWidth, this.$container)
    this.foilWidth = this.$foilWidth.attr(data.foilWidth)

    this.$spareparts = $(selectors.spareparts, this.$container)

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.hasQuantity) {
      var quantityParam = theme.Utils.getUrlParam('quantity')
      this.quantity = quantityParam || 1
      if (quantityParam) {
        this.$quantitySelect.val(quantityParam)
        var variant = this.variants.currentVariant
        this.updateProductPrices({ variant: variant })
        this.updateSquareMeters()
      }
      this.$quantitySelect.on('change', function(e){
        this.quantity = e.target.value
        var variant = this.variants.currentVariant
        this.updateProductPrices({ variant: variant })
        this.updateSquareMeters()
        //Add quantity to url
        if (!history.replaceState) {
          return
        }
        theme.Utils.updateQueryStringParam('quantity', e.target.value)
      }.bind(this))
    }

    if (this.hasCollectionVariants) {
      this.loadCollectionVariants()
      this.$collectionVariantSelect.on('change', function(e){
        var handle = e.target.value
        var collection = this.productCollection ? '/collections/' + this.productCollection : ''
        var quantity = this.quantity ? '?quantity='+this.quantity : ''
        window.location = collection + '/products/' + handle + quantity
      }.bind(this))
    }

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }

    //Setup AJAX cart
    if (theme.settings.cartAjaxEnable) {
      this.initAjaxCart()
    }

    if ($(this.$container).attr(data.isSparepartGroup)) {
      this.sparepartsArray = JSON.parse($(selectors.sparepartsJSON, this.$container).html())
      this.loadSpareparts()
      if (!Modernizr.touchevents) {
        $('.easyzoom').easyZoom({
          preventClicks: true,
        })
      }
    } else {
      this.initFlickityGallery()

    }

    if (Modernizr.touchevents) {
      $('.tabs input[type="radio"]:checked').prop('checked', false)
    }

    $('.product__reviews-badge').on('click', function(){
      $('#reviews').click();
    })
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('d-none');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('d-none');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
        $(selectors.addToCart, this.$container).removeClass(classNames.addToCartSoldOut).addClass(classNames.addToCartAvailable);
        $(selectors.stock, this.$container).html(theme.strings.inStock).removeClass(classNames.outOfStock).addClass(classNames.inStock);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
        $(selectors.addToCart, this.$container).removeClass(classNames.addToCartAvailable).addClass(classNames.addToCartSoldOut);
        $(selectors.stock, this.$container).html(theme.strings.outOfStock).removeClass(classNames.inStock).addClass(classNames.outOfStock);
      }

    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $comparePercent = $(selectors.comparePercent, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container).add($comparePercent)
      var quantity = this.quantity || 1
      var price = variant.price * quantity

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(price, theme.moneyFormat, variant.taxable));

      if (variant.compare_at_price > variant.price) {
        var compare_at_price = quantity * variant.compare_at_price
        $comparePrice.html(slate.Currency.formatMoney(compare_at_price, theme.moneyFormat, variant.taxable));
        var money_saved = (variant.compare_at_price - variant.price) * 100
        var percent_saved = Math.floor(money_saved / variant.compare_at_price)
        $comparePercent.html(theme.strings.savePercent + ' ' + percent_saved + '%')
        $compareEls.removeClass('d-none');
      } else {
        $comparePrice.html('');
        $comparePercent.html('');
        $compareEls.addClass('d-none');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    },

    /**
     * Initialize flickity gallery
     */
    initFlickityGallery: function() {
      var $carousel = $('.product__image-carousel').flickity({
        wrapAround: true,
        imagesLoaded: true,
        dragThreshold: 10,
        setGallerySize: true,
        pageDots: false
      })
      var $carouselCells = $carousel.find('.carousel-cell')
      if ($carouselCells.length < 2) {
        $carousel.find('.flickity-prev-next-button').addClass('invisible')
      }
      $carousel.removeClass('invisible')

      var $carouselNav = $('.product__image-carousel-nav')
      var $carouselNavCells = $carouselNav.find('.carousel-cell')

      $carouselNav.on('click', '.carousel-cell', function(event) {
        var index = $(event.currentTarget).index()
        $carousel.flickity('select', index)
      })

      var $carouselModal = $('.product__image-modal__carousel')
      var modalIndex = 0
      $carousel.on('click', '.carousel-cell', function(event) {
        modalIndex = $(event.currentTarget).index()
        $('.product__image-modal').modal()
      })
      $('.product__image-modal').on('shown.bs.modal', function (e) {
        $carouselModal.flickity({
          pageDots: false,
          initialIndex: modalIndex,
          wrapAround: true,
        })
        $carouselModal.flickity('select', modalIndex, null, true)
      })

      var flkty = $carousel.data('flickity')

      $carousel.on('select.flickity', function() {
        // set selected nav cell
        $carouselNav.find('.is-nav-selected').removeClass('is-nav-selected')
        var $selected = $carouselNavCells
          .eq(flkty.selectedIndex)
          .addClass('is-nav-selected')
      })

      document.addEventListener('lazyloaded', function(e){
        $carousel.flickity('resize')
      });

      $carousel.on( 'fullscreenChange.flickity', function( event, isFullscreen ) {
        lazySizes.autoSizer.checkElems();
      });

    },

    initAjaxCart: function(){
      var self = this
      $(document).on('click', selectors.addToCart, function(e){
        e.preventDefault()
        var $this = $(this)
        $this.removeClass('is-done').toggleClass('is-loading')
        if ($this.attr(data.sparepartVariantID)) {
          var variant_id = $this.attr(data.sparepartVariantID)
        } else {
          var variant_id = self.variants.currentVariant.id
        }
        var quantity = self.quantity || 1
        var properties = self.hasQuantity
          ? { _timestamp: Date.now() }
          : {}
        CartJS.addItem(
          variant_id,
          quantity,
          properties,
          {
            success: function(data, textStatus, jqXHR) {
              // Open cart
              $('html').addClass('ajax-cart--toggled')
              $this.toggleClass('is-loading').addClass('is-done')
            },
            error: function(jqXHR, textStatus, errorThrown) {
              var response = $.parseJSON(jqXHR.responseText);
              self.$cartError.html(response.description).addClass('d-block')
              $this.toggleClass('is-loading')
            }
          }
        )
      })
    },
    loadCollectionVariants: function(){
      var self = this
      $.ajax({
        url: '/collections/types?q='+self.collectionVariantType+'&view=feed',
        success: function(data){
          var product_list = JSON.parse(data)
          var products = product_list.products
          var collection_variant_options = ''
          for (var i = 0; i < products.length; i++) {
            var p = products[i]
            var foil_width = p.shoptimist_metafields.foil_width
            if (foil_width) {
              foil_width = foil_width.replace('.', ',')
            }
            collection_variant_options += '<option value="'+p.handle+'">'+foil_width+'</option>'
          }
          self.$collectionVariantSelect.append(collection_variant_options).val(self.productSingleObject.handle)
        }
      })
    },
    updateSquareMeters: function(){
      if (!this.foilWidth) {
        return
      }
      var self = this
      var foil_width_text = this.foilWidth.replace('.', ',')
      var display_price = slate.Currency.formatMoney(this.variants.currentVariant.price * this.quantity, theme.moneyFormatWithoutCurrency)
      var square_meter_price = slate.Currency.formatMoney(this.variants.currentVariant.price / this.foilWidth, theme.moneyFormat)
      var square_meters = this.quantity * this.foilWidth
      square_meters = square_meters.toFixed(2).toString().replace('.', ',')
      var square_meter_string = theme.strings.squareMeterHtml.replace(/\{{ quantity }}/g, self.quantity)
      square_meter_string = square_meter_string.replace(/\{{ foil_width_text }}/g, foil_width_text)
      square_meter_string = square_meter_string.replace(/\{{ square_meters }}/g, square_meters)
      square_meter_string = square_meter_string.replace(/\{{ square_meter_price }}/g, square_meter_price)
      square_meter_string = square_meter_string.replace(/\{{ display_price }}/g, display_price)
      this.$foilWidth.html(square_meter_string)
    },
    loadSpareparts: function(){
      var self = this
      // We've already loaded 20 parts in liquid, so let's see if there are more than that
      var remaining_parts = this.sparepartsArray.slice(20)
      if (remaining_parts.length == 0) {
        return
      }
      var remaining_parts_shopify = []
      var deffered = []
      for (var i = 0; i < remaining_parts.length; i++) {
        var p = remaining_parts[i].split('_')
        var handle = p[0]
        var d = $.getJSON('/products/'+handle+'.js', (function(i){
          return function(data){
            var inner_p = remaining_parts[i].split('_')
            var part_data = {}
            part_data.product = data
            part_data.quantity_included = inner_p[1]
            part_data.image_reference = inner_p[2]
            remaining_parts_shopify.push(part_data)
          }
        })(i))
        deffered.push(d)
      }
      $.when.apply(undefined, deffered).then(function(){
        var parts_html = ''
        remaining_parts_shopify.sort(function(o1, o2){ return o1.image_reference - o2.image_reference })
        for (var i = 0; i < remaining_parts_shopify.length; i++) {
          var s = remaining_parts_shopify[i]
          var quantity_included = s.quantity_included != '1'
            ? s.quantity_included + ' x '
            : ''
          var button_available_class = s.product.available
            ? 'btn-primary'
            : 'btn-danger'
          var button_disabled = s.product.available
            ? ''
            : 'disabled="disabled"'
          var button_text = s.product.available
            ? theme.strings.addToCart
            : theme.strings.soldOut
          parts_html += '<tr>'+
            '<td>'+quantity_included+s.product.variants[0].sku+'</td>'+
            '<td>'+s.image_reference+'</td>'+
            '<td>'+slate.Currency.formatMoney(s.product.price, theme.moneyFormat)+'</td>'+
            '<td>'+
              '<button'+
                ' type="submit"'+
                ' name="add"'+
                ' class="btn btn-sm '+button_available_class+'"'+
                ' '+button_disabled+
                ' data-add-to-cart'+
                ' data-sparepart-variant-id="'+s.product.variants[0].id+'">'+
                  '<span data-add-to-cart-text>'+button_text+'</span>'+
                  '<i class="fal fa-spinner-third fa-spin fa-fw btn-loader"></i>'+
                  '<i class="fal fa-check fa-fw btn-done"></i>'+
              '</button>'+
            '</td>'+
          '</tr>'
        }
        self.$spareparts.find('tbody').append(parts_html)
      })
    }

  });

  return Product;
})();

/**
 * Article Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Article template.
 *
   * @namespace article
 */

theme.Article = (function() {

  var selectors = {
    articleContent: '[data-article-content]',
    navigation: '[data-article-navigation]'
  };

  /**
   * Article section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Article(container) {
    this.$container = $(container);

    this.initNavigation()
  }

  Article.prototype = $.extend({}, Article.prototype, {

    initNavigation: function() {

      var $nav = $(selectors.navigation, this.$container)

      var linksString = ''
      $('h1, h2, h3', selectors.articleContent, this.$container).each(function(idx){
        $this = $(this)
        var title = $this.text()
        var id = title.toLowerCase().trim().replace(/\s/g, '') + '-' + idx
        $this.attr('id', id)

        linksString += '<a class="nav-link" href="#'+id+'">'+title+'</a>'
      })
      $nav.find('nav').append(linksString)
      $nav.stick_in_parent({
        offset_top: 20,
      })

      $('body').scrollspy({ target: selectors.navigation, offset: 50 })

    }

  });

  return Article;
})();

/**
 * Collection Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the collection template.
 *
   * @namespace collection
 */

theme.Collection = (function() {

  var selectors = {
    sort_by: '[data-collection-sort-by]',
    filter_container: '[data-filter-container]',
    filter_items: '[data-filter-items]',
    filter_clear_all: '[data-filter-clear-all]',
    collection_header: '[data-collection-header]',
    collection_header_spacer: '[data-collection-header-spacer]',
    collection_no_transform: '[data-no-transform]',
    collection_header_content: '[data-collection-header-content]',
    spareparts_select: '[data-spareparts-select]'
  }
  var data = {
    default_sort_by: 'default-sort',
    is_spareparts: 'data-spareparts-collection',
    collection_handle: 'data-collection-handle',
    remove_title: 'data-remove-title'
  }
  var classNames = {
    filter_container_open: 'collection__filter-container--open',
    collection_header_collapsed: 'collection__header--collapsed',
  }

  /**
   * Article section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Collection(container) {
    this.$container = $(container);

    this.$sortBy = $(selectors.sort_by, this.$container)
    this.defaultSort = this.$sortBy.data(data.default_sort_by)

    this.$collectionHeader = $(selectors.collection_header, this.$container)
    this.$collectionHeaderSpacer = $(selectors.collection_header_spacer, this.$container)
    this.$collectionNoTransform = $(selectors.collection_no_transform, this.$container)
    this.$collectionHeaderContent = $(selectors.collection_header_content, this.$container)

    this.collectionHandle = this.$container.attr(data.collection_handle)
    this.$sparepartsSelect = $(selectors.spareparts_select, this.$container)

    this.$filterContainer = $(selectors.filter_container, this.$container)
    this.$filterItems = $(selectors.filter_items, this.$container)
    this.$clearAll = $(selectors.filter_clear_all, this.$container)


    this.initSortBy()
    this.initCollectionHeader()

    if ($('.sticky-nav').length) {
      $('.sticky-nav').stick_in_parent({ offset_top: 96 })

      var mainNavLinks = document.querySelectorAll(".sticky-nav a");
      var mainSections = document.querySelectorAll("section.campaign-collection");

      var lastId;
      var cur = [];

      // This should probably be throttled.
      // Especially because it triggers during smooth scrolling.
      // https://lodash.com/docs/4.17.10#throttle
      // You could do like...
      // window.addEventListener("scroll", () => {
      //    _.throttle(doThatStuff, 100);
      // });
      // Only not doing it here to keep this Pen dependency-free.

      window.addEventListener("scroll", function(event) {
        
          var fromTop = window.scrollY;
  
          mainNavLinks.forEach(function (link) {
            var section = document.querySelector(link.hash);
  
            if (
              section.offsetTop <= fromTop &&
              section.offsetTop + section.offsetHeight > fromTop
            ) {
              link.classList.add("current");
            } else {
              link.classList.remove("current");
            }
          });
      });
    }

    if (this.$container.attr(data.is_spareparts)) {
      this.loadAllSpareparts()
      this.$sparepartsSelect.change(function(e){
        window.location = e.target.value
      })
    }

    if (bcsffilter !== undefined) {
      this.BCFilterBinding()
    }
  }

  Collection.prototype = $.extend({}, Collection.prototype, {

    initSortBy: function() {
      Shopify.queryParams = {}
      if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=')
          if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1])
          }
        }
      }

      this.$sortBy
        .val(this.defaultSort)
        .bind('change', function() {
          Shopify.queryParams.sort_by = $(this).val()
          location.search = $.param(Shopify.queryParams).replace(/\+/g, '%20')
        })

    },
    BCFilterBinding: function() {
      var self = this
      var _afterBuildFilterTree = bcsffilter.afterBuildFilterTree
      var _clearAllFilterOptions = window.clearAllFilterOptions

      bcsffilter.afterBuildFilterTree = function () {
        _afterBuildFilterTree.apply(bcsffilter, arguments)
        setTimeout(function(){
          var $items = $('.bc-sf-filter-selected-items .selected-item')
          if ($items.length < 1) {
            self.$filterContainer.removeClass(classNames.filter_container_open)
            self.$filterItems.empty()
            return
          }
          var newItems = ''
          $items.each(function() {
            var $item = $(this).find('a')
            var itemUrl = $item.attr('href')
            var itemTitle = $item.text()
            newItems += '<li class="mr-2 mb-2"><a href="'+itemUrl+'"><span class="badge badge-secondary p-2">'+itemTitle+'<i class="fal fa-times ml-2"></i></span></a></li>'
          })
          self.$filterItems.html(newItems)
          self.$filterContainer.addClass(classNames.filter_container_open)
          bcsffilter.buildClearEvent()
        }, 100)
      }

      window.clearAllFilterOptions = function () {
        _clearAllFilterOptions.apply(window, arguments)
        setTimeout(function(){
          self.$filterItems.empty()
          self.$filterContainer.removeClass(classNames.filter_container_open)
        }, 100)
      }

      self.$clearAll.click(function(e) {
        window.clearAllFilterOptions(e)
      })
    },
    initCollectionHeader: function() {
      var self = this

      var collection_height = self.$collectionHeader.height()
      var offset = self.$collectionHeader.offset()
      var min_height = self.$collectionHeader.css('min-height')
      var content_height = self.$collectionHeaderContent.outerHeight()
      var header_height = theme.js.header_height_collapsed
      min_height = parseInt(min_height, 10)

      $(window).on('scroll', function(){
				//The window.requestAnimationFrame() method tells the browser that you wish to perform an animation- the browser can optimize it so animations will be smoother
				//window.requestAnimationFrame(scrollCollectionHeader);
			})

      var window_width = $(window).width()

      $(window).resize(function(){
        // Fix bug on mobile where resize event is fired while also scrolling
        if ($(window).width() != window_width ) {
          collection_height = self.$collectionHeader.height()
          offset = self.$collectionHeader.offset()
          content_height = self.$collectionHeaderContent.outerHeight()
          //window.requestAnimationFrame(scrollCollectionHeader);
        }
      })



      /*self.$collectionHeader.stick_in_parent({
        offset_top: header_height,
        spacer: self.$collectionHeaderSpacer,
        parent: self.$container,
        bottoming: false,
      })*/

      //scrollCollectionHeader()

      function scrollCollectionHeader() {
        var scroll_top = $(window).scrollTop()
        var new_height = collection_height - (scroll_top - (offset.top - header_height))
        if (scroll_top >= (offset.top - header_height) && new_height < collection_height) {
          new_height = new_height >= min_height ? new_height : min_height
          var scale = new_height / collection_height
          var scale_opposite = 1 / scale
          self.$collectionHeader.css('transform', 'scaleY('+scale+') translateZ(0px)')
          self.$collectionNoTransform.css('transform', 'scaleY('+scale_opposite+') translateZ(0px)')
          if (new_height < content_height) {
            self.$collectionHeader.addClass(classNames.collection_header_collapsed)
          } else {
            self.$collectionHeader.removeClass(classNames.collection_header_collapsed)
          }
        } else {
          self.$collectionHeader.css('transform', 'scaleY(1) translateZ(0px)')
          self.$collectionNoTransform.css('transform', 'scaleY(1) translateZ(0px)')
        }
      }
    },
    loadAllSpareparts: function(){
      var self = this
      self.$sparepartsSelect.next().find('.fa-spin').toggleClass('invisible')
      var remove_title = self.$container.attr(data.remove_title)
      $.ajax({
        url: '/collections/'+this.collectionHandle+'?view=feed-simple',
        success: function(data){
          var product_list = JSON.parse(data)
          var products = product_list.products
          var sparepart_options = ''
          for (var i = 0; i < products.length; i++) {
            var sparepart = products[i]
            var url = '/collections/'+self.collectionHandle+sparepart.url
            var title = sparepart.title.replace(remove_title, '')
            sparepart_options += '<option value="'+url+'">'+title+'</option>'
          }
          self.$sparepartsSelect.append(sparepart_options).attr('disabled', false)
          self.$sparepartsSelect.next().find('.fa-spin').toggleClass('invisible')
        }
      })
    }
  });

  return Collection;
})();

/**
 * Campaign Monitor Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Campaign Monitor signup forms.
 *
   * @namespace campaign
 */

theme.Campaign = (function() {

  var selectors = {
    form: '[data-campaign-form]',
    hiddenForm: '[data-campaign-hidden-form] form',
    submitButton: '[data-submit-button]',
    alertSuccess: '[data-alert-success]',
    alertError: '[data-alert-error]'
  };

  /**
   * Article section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Campaign(container) {
    this.$container = $(container);

    this.$form = $(selectors.form, this.$container)
    this.$hiddenForm = $(selectors.hiddenForm, this.$container)
    this.$submitButton = $(selectors.submitButton, this.$container)
    this.$alertSuccess = $(selectors.alertSuccess, this.$container)
    this.$alertError = $(selectors.alertError, this.$container)

    this.setupAJAX()
    this.coupleForms()

  }

  Campaign.prototype = $.extend({}, Campaign.prototype, {

    coupleForms: function() {

      var self = this

      this.$form.submit(function(e) {
        e.preventDefault()
        var inputValue = $(this).find('input[type="email"]').val()
        // Put input value in the hidden form
        self.$hiddenForm.find('input[type="email"]').val(inputValue)
        self.$hiddenForm.submit()
      })
    },
    setupAJAX: function() {
      var self = this

      var form_id = this.$hiddenForm.attr('data-id');

      this.$hiddenForm.submit(function (evt) {
        var $this = $(this)

        self.$alertError.addClass('d-none')
        self.$alertSuccess.addClass('d-none')
        self.$submitButton.toggleClass('is-loading')

        // Disable default form submit.
        evt.preventDefault();

        // Get e-mail value.
        email = $this.find('input[type="email"]').val();

        // Build request data for tokenRequest.
        request_data = "email=" + encodeURIComponent(email) + "&data=" + form_id;

        // Prepare tokenRequest.
        tokenRequest = new XMLHttpRequest();
        tokenRequest.open('POST', 'https://createsend.com//t/getsecuresubscribelink', true);
        tokenRequest.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        tokenRequest.send(request_data);

        // Ready state.
        tokenRequest.onreadystatechange = function() {
          if (this.readyState === 4) {
            if (this.status === 200) {
              // Having token and new submit url we can create new request to subscribe a user.
              subscribeRequest = new XMLHttpRequest();
              subscribeRequest.open('POST', this.responseText, true);
              subscribeRequest.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
              subscribeRequest.send($this.serialize());
              // On ready state call response function.
              subscribeRequest.onreadystatechange = function() {
                self.response(subscribeRequest);
              }
            } else {
              self.response(tokenRequest);
            }
          }
        }
      })

  },
  response: function(request) {
    var self = this
    if (request.readyState === 4) {
      if (request.status === 200) {
        self.$alertSuccess.html(theme.strings.newsletterSubscribeSuccess).removeClass('d-none')
        //Set popup cookie to 1 year
        theme.Popup.setCookie(365)
      } else {
        self.$alertError.html(theme.strings.newsletterSubscribeError).removeClass('d-none')
      }
      self.$submitButton.toggleClass('is-loading')
    }
  }
  });

  return Campaign;
})();

/**
 * Maps Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to google maps
 *
 * @namespace maps
 */

theme.Maps = (function() {
  var config = {
    zoom: 10
  }

  var apiStatus = null
  var mapsToLoad = []

  var selectors = {
    map: '[data-map]'
  }
  var data = {
    apiKey: 'api-key',
    addressSetting: 'address-setting',
    mapWaterColor: 'water-color'
  }

  function Map(container) {
    this.$container = $(container)
    this.$map = $(selectors.map, this.$container)
    this.key = this.$map.data(data.apiKey)
    var waterColor = this.$map.data(data.mapWaterColor)

    this.styles = [ { "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [ { "color": "#444444" } ] }, { "featureType": "landscape", "elementType": "all", "stylers": [ { "color": "#f2f2f2" } ] }, { "featureType": "poi", "elementType": "all", "stylers": [ { "visibility": "off" } ] }, { "featureType": "road", "elementType": "all", "stylers": [ { "saturation": -100 }, { "lightness": 45 } ] }, { "featureType": "road.highway", "elementType": "all", "stylers": [ { "visibility": "simplified" } ] }, { "featureType": "road.arterial", "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "all", "stylers": [ { "visibility": "off" } ] }, { "featureType": "water", "elementType": "all", "stylers": [ { "color": waterColor }, { "visibility": "on" } ] } ]

    if (!this.key) {
      return
    }

    if (apiStatus === 'loaded') {
      this.createMap()
    } else {
      mapsToLoad.push(this)

      if (apiStatus !== 'loading') {
        apiStatus = 'loading'
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.key
          ).then(function() {
            apiStatus = 'loaded'
            initAllMaps()
          })
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap()
    })
  }

  function geolocate($map) {
    var deferred = $.Deferred()
    var geocoder = new google.maps.Geocoder()
    var address = $map.data(data.addressSetting)

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status)
      }

      deferred.resolve(results)
    })

    return deferred
  }

  Map.prototype = $.extend({}, Map.prototype, {
    createMap: function() {
      var $map = this.$map

      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              draggable: true,
              clickableIcons: false,
              scrollwheel: false,
              disableDefaultUI: true,
              styles: this.styles
            }

            var map = (this.map = new google.maps.Map($map[0], mapOptions))
            var center = (this.center = map.getCenter())

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter()
            })

            google.maps.event.addDomListener(
              window,
              'resize',
              $.debounce(250, function() {
                google.maps.event.trigger(map, 'resize')
                map.setCenter(center)
              })
            )
          }.bind(this)
        )
        .fail(function(status) {
          console.log(status)
        })
    },

    onUnload: function() {
      if (this.$map.length === 0) {
        return
      }
      // Causes a harmless JS error when a section without an active map is reloaded
      google.maps.event.clearListeners(this.map, 'resize')
    }
  })

  return Map
})()

/**
 * Gallery Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the gallery section.
 *
   * @namespace gallery
 */

theme.Gallery = (function() {

  var selectors = {
    images: '[data-raw-images]',
  }
  /**
   * Gallery section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Gallery(container) {
    this.$container = $(container);

    this.$images = $(selectors.images, this.$container).find('img')

    this.initGallery()
  }

  Gallery.prototype = $.extend({}, Gallery.prototype, {

    initGallery: function() {
      this.$container.html(this.$images)

      this.$images.wrap('<div class="gallery__cell carousel-cell" />')

      this.$images.each(function() {
        var $this = $(this)
        var alt = $this.attr('alt')
        if (alt === '') {
          return
        }
        $this.parent().append('<div class="gallery__alt-text">'+alt+'</div>')
      })

      this.$container.show()
      this.$container.flickity({
        wrapAround: true,
        // setGallerySize: true
      })
    }
  });

  return Gallery;
})();

/**
 * Header Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the header template.
 *
   * @namespace header
 */

theme.Header = (function() {

  theme.js.header_height_expanded = 7 * theme.Utils.rem()
  theme.js.header_height_collapsed = 4 * theme.Utils.rem()

  var selectors = {
    mobile_menu: '[data-mobile-menu]',
    site_banner: '[data-site-banner]',
    site_banner_close: '[data-site-banner-close]',
    search_form: '[data-header-search]',
    mobile_search_form: '[data-mobile-header-search]',
    mobile_search_trigger: '[data-mobile-search-trigger]',
    mobile_menu_nav: '[data-mobile-menu-nav]',
  }

  /**
   * Article section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Header(container) {
    this.$container = $(container);

    this.$mobileMenu = $(selectors.mobile_menu, this.$container)

    this.$searchForm = $(selectors.search_form, this.$container)
    this.$mobileSearchForm = $(selectors.mobile_search_form, this.$container)
    this.$searchTrigger = $(selectors.search_trigger, this.$container)

    this.$siteBanner = $(selectors.site_banner, this.$container)
    this.$siteBannerClose = $(selectors.site_banner_close, this.$container)

    this.$searchForm = $(selectors.search_form, this.$container)

    this.initSiteBanner()

    if ($('html').hasClass('has-fixed-menu')) {
      this.menuScroll()
    }
    
    $(document).on('click','.search-icon-mobile', function() {
      $('html').toggleClass('header--show-search-bar')
    });

    this.$searchForm.submit(function(e) {
      if ($('input[name="q"]').val() == '') {
        e.preventDefault()
      }
    })

    var searchInput = this.$searchForm.find('input[name="q"]')
    theme.Utils.removeWildCards(searchInput)
    var mobileSearchInput = this.$mobileSearchForm.find('input[name="q"]') 
    theme.Utils.removeWildCards(mobileSearchInput)

    this.$searchForm.submit(function(e) {
      console.log('search?')
      theme.Utils.handleSearch(e, searchInput)
    })

    this.$mobileSearchForm.submit(function(e) {
      console.log('mobile search?')
      theme.Utils.handleSearch(e, mobileSearchInput)
    })

    if (!Modernizr.focuswithin) {
      this.$searchForm.on('mouseenter',function(){
        $(this).addClass('focused')
      })
      this.$searchForm.on('mouseleave',function(){
        if (!$(this).find('input').is(':focus')) {
          $(this).removeClass('focused')
        }
      })
      this.$searchForm.on('focusout',function(){
        $(this).removeClass('focused')
      })
    }

    var accordionsMenu = $('.cd-accordion-menu');

    if( accordionsMenu.length > 0 ) {
      
      accordionsMenu.each(function(){
        var accordion = $(this);
        //detect change in the input[type="checkbox"] value
        accordion.on('change', 'input[type="checkbox"]', function(){
          var checkbox = $(this);
          console.log(checkbox.prop('checked'));
          ( checkbox.prop('checked') ) ? checkbox.siblings('ul').attr('style', 'display:none;').slideDown(300) : checkbox.siblings('ul').attr('style', 'display:block;').slideUp(300);
        });
      });
    }

  }

  Header.prototype = $.extend({}, Header.prototype, {

    initSiteBanner: function() {
      var self = this
      // var bannerShown = Cookies.get('banner_shown')

      // if (!bannerShown) {
        theme.js.header_height_collapsed = theme.js.header_height_collapsed + (theme.Utils.rem() * 2)
        $('html').addClass('header-banner--open')
      // }

      // this.$siteBannerClose.click(function() {
      //   $('html').removeClass('header-banner--open')
      //   Cookies.set('banner_shown', true)
      // })

    },
    menuScroll: function() {
      var self = this
      self.checkScroll()
      $(window).scroll($.throttle(100, self.checkScroll))
    },
    checkScroll: function() {
      var scroll = $(window).scrollTop()
      if (scroll >= 5) $('html').addClass('is-scrolled')
      else $('html').removeClass('is-scrolled')
    }
  });

  return Header;
})();

/**
 * Popup Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the popup template.
 *
   * @namespace popup
 */

theme.Popup = (function() {

  var selectors = {
  }
  var data = {
    popup_expiry: 'popup-expiry',
    popup_click_max: 'popup-click-max',
    popup_idle_max: 'popup-idle-max',
  }
  /**
   * Article section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Popup(container) {
    this.$container = $(container);

    this.popupExpiry = this.$container.data(data.popup_expiry)
    this.popupClickMax = this.$container.data(data.popup_click_max)
    this.popupIdleMax = this.$container.data(data.popup_idle_max)

    this.init()
  }

  Popup.prototype = $.extend({}, Popup.prototype, {

    init: function() {
      var self = this

      if (!Cookies.get('popup_shown')) {
        this.documentClicks = localStorage.getItem('popup_clicks') ? localStorage.getItem('popup_clicks') : 0

        $(document).on('click.popup', function(){
          self.documentClicks ++
          localStorage.setItem('popup_clicks', self.documentClicks)
        })

        this.idleTime = 0
        //Increment the idle time counter every X seconds.
        this.idleInterval = setInterval(this.timerIncrement.bind(this), 1000)

        //Zero the idle timer on mouse movement.
        $(document).on('mousemove.popup', function (e) {
          self.idleTime = 0;
        });
        $(document).on('keypress.popup', function (e) {
          self.idleTime = 0;
        });

      }

    },
    timerIncrement: function() {
      this.idleTime = this.idleTime + 1
      this.tryOpenPopup()
    },
    tryOpenPopup: function(){
      var self = this
      if (this.documentClicks >= this.popupClickMax || this.idleTime >= this.popupIdleMax ) {
        localStorage.removeItem('popup_clicks')
        // Delay a bit to make sure popup doesn't occur on a page transition
        setTimeout(function(){
          self.$container.modal()
          clearInterval(self.idleInterval)
          $(document).off('mousemove.popup')
          $(document).off('keypress.popup')
          $(document).off('click.popup')
          Popup.setCookie(self.popupExpiry)
        }, 1500)
      }
    }
  })

  // Expose this to Popup class so it can be used by campaign js
  Popup.setCookie = function(expiry) {
    Cookies.set('popup_shown', 'true', { expires: expiry });
  }

  return Popup;
})();

/**
 * Autotype Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the autotype template.
 *
   * @namespace autotype
 */

theme.Autotype = (function() {

  var selectors = {
    typed_element: '[data-typed-element]',
  }
  var data = {
    typed_strings: 'typed-strings'
  }
  /**
   * Article section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Autotype(container) {
    this.$container = $(container);

    this.$typedElement = $(selectors.typed_element, this.$container)
    this.typedStrings = this.$typedElement.data(data.typed_strings).split(',')

    this.init()
  }

  Autotype.prototype = $.extend({}, Autotype.prototype, {

    init: function() {
      var self = this

      var options = {
        strings: self.typedStrings,
        typeSpeed: 80,
        loop: true,
        // startDelay: 1000,
        backDelay: 1000,
      }

      var typed = new Typed(selectors.typed_element, options)
    },
  });

  return Autotype;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('d-none');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('d-none');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {

  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('d-none');
    $('#CustomerLoginForm').toggleClass('d-none');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('d-none');
  }
})();

/**
 * Search Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the search
 * template.
 *
 * @namespace Search
 */
theme.Search = (function() {
    //Functionality for handling butikker list
    var config = {
      searchForm: 'form.search-form',
    };
  
    if (!$(config.searchForm).length) {
      return;
    }
  
    self = this;
    var searchForm = $(config.searchForm)
    var searchInput = searchForm.find('input[name="q"]')
    
    searchInput.focus(function() {
      theme.Utils.removeWildCards(searchInput)
    })
    searchForm.submit(function(e) {
      theme.Utils.handleSearch(e, searchInput)
    })
    setTimeout(function() {
      theme.Utils.removeWildCards(searchInput)
    }, 50)
  })();
  
/**
 * Search Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the page auction
 * template.
 *
 * @namespace Auction
 */
theme.Auction = (function() {

  
  function SortByStartsAt(a, b){
    var aName = new Date(a.starts_at);
    var bName = new Date(b.starts_at); 
    return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
  }


  function getUpcomingAuctions() {
    $.post('/apps/timer', {upcoming: true }).done(function(r) {
      var sorted = r.upcoming.sort(SortByStartsAt)
      var nextAuction = null;
      for (var i = 0; i < sorted.length; i++) {
        var auction = sorted[i];
        if (auction.starts_at) {
          nextAuction = auction;
          break;
        }
      }
      if (nextAuction) {
        $.ajax({
          url: '/collections/' + nextAuction.handle + '?view=auction-feed',
          contentType: 'application/json',
          success: function(retVal) {
            //console.log("Upcoming auction product: ", JSON.parse(retVal));
            var res = JSON.parse(retVal);
            var collectionId = res[0].collection_id;
            var product = res[0].product;
            auctionContainer.find('.upcomingProduct').html(product.title);
          },
          error: function() {

          }
        })
        auctionContainer.find('.auction-sold').show();
        auctionContainer.find('.nextAuctionTime').html(moment(nextAuction.starts_at).format('HH:mm')) //TODO: Calculate if its tomorrow or today
      } else {
        auctionContainer.find('.auction-inactive').show();
      }
    })
  }

  //Functionality for handling butikker list
  var config = {
    auctionContainerSelector: 'div.page section.auction',
    auctionWidgetContainerSelector: '.auction-product-widget',
  };
  
  var auctionContainer = $(config.auctionContainerSelector)
  var auctionWidgetContainer = $(config.auctionWidgetContainerSelector)

  if (auctionContainer.length) {
    $.post('/apps/timer', {running: true }).done(function(retVal) {
      if (retVal.running && retVal.running.length) {
        var auction = null
        for (var i = 0; i < retVal.running.length; i++) {
          var tmpAuction = retVal.running[i]
          var auctionDate = moment(tmpAuction.starts_at)
          if (moment().isSame(auctionDate.format('YYYY-MM-DD'), 'day')) {
            auction = tmpAuction
            break
          }
        }
        if (!auction) {
          getUpcomingAuctions()
          return
        }
        //var auction = retVal.running[0]
        var collectionHandle = auction.handle;
        //Fetch collection and product
        $.ajax({
          url: '/collections/' + collectionHandle + '?view=auction-feed',
          contentType: 'application/json',
          success: function(retVal) {
            var res = JSON.parse(retVal);
            if (!res || !res.length) {
              getUpcomingAuctions();
              return;
            }
            var collectionId = res[0].collection_id;
            var product = res[0].product;
            var originalPrice = 0;
            if (res[0].metafields && res[0].metafields.length) {
              var priceField = res[0].metafields[0];
              if (priceField.value.indexOf('{') > -1) {
                var prices = JSON.parse(priceField.value)
                originalPrice = prices[[product.variants[0].id]]
              } else {
                  originalPrice = res[0].metafields && res[0].metafields.length ? res[0].metafields[0].value : 28720;
              }
            }
            
            auctionContainer.find('.title').html(product.title);
            auctionContainer.find('.auction-product-image').attr('src', product.images[0]);
            auctionContainer.find('.auction-active').show();
            if (!originalPrice) {
              auctionContainer.find('.originalPrice').parent().hide();
              auctionContainer.find('.saveAmount').parent().hide();
            } else {
              auctionContainer.find('.originalPrice').html((originalPrice / 100).toFixed(2) + ' kr.');
              var savePercentage = 100 - (((product.price) / (originalPrice)) * 100)
              auctionContainer.find('.saveAmount').html(savePercentage.toFixed(0) + '%');
            }
            auctionContainer.find('.currentPrice').html((product.price / 100).toFixed(2) + ' kr.');
            auctionContainer.find('.productLink').attr('href', '/products/' + product.handle);
  
            $.post('/apps/timer', {id: collectionId }).done(function(r) {
              //console.log(r);
              //var x = JSON.parse(r);
              x = r;
              //console.log(x);
              moment.locale('da');
              var next = moment(x.timer, 'X');
              //console.log(next.format('HH:mm'));
              auctionContainer.find(".nextPriceDrop").text(next.format('HH:mm'));
              moment.locale('en');
              var next = moment(x.timer);
            })
          },
          error: function() {
            
          }
        })
      } else {
        getUpcomingAuctions();
      }
    });
  }

  if (auctionWidgetContainer.length) {
    if (!window.auctionProductOriginalPrice) {
      return
    }
    var originalPrice = window.auctionProductOriginalPrice
    var product = JSON.parse($('[data-product-json]').html());
    if (originalPrice.indexOf('{') > -1) {
      var prices = JSON.parse(originalPrice)
      originalPrice = prices[product.variants[0].id]
    }
    auctionWidgetContainer.find('.originalPrice').html((originalPrice / 100).toFixed(2) + ' kr.');
    var savePercentage = 100 - (((product.price) / (originalPrice)) * 100)
    auctionWidgetContainer.find('.saveAmount').html(savePercentage.toFixed(0) + '%');
    auctionWidgetContainer.next().hide();
    $('[data-price-wrapper]').hide();
    auctionWidgetContainer.show();
  }

  
})();
  

$(document).ready(function() {

  // <!-- Initialize BCSFilter App -->
  window.bcsffilter = new BCSfFilter();
  bcsffilter.init();

  // <!-- Initialize & Customize Filter -->
  if ($('body').hasClass('template-collection')) {
    bcsffilter.initFilter()
  }

  // <!-- Initialize & Customize Search -->
  bcsffilter.initSearchBox()


  var sections = new slate.Sections();
  sections.register('header', theme.Header)
  sections.register('popup', theme.Popup)
  sections.register('product', theme.Product)
  sections.register('article', theme.Article)
  sections.register('collection', theme.Collection)
  sections.register('campaign', theme.Campaign)
  sections.register('maps', theme.Maps)
  sections.register('gallery', theme.Gallery)
  sections.register('autotype', theme.Autotype)

  theme.elementToggleClass()

  if (theme.settings.cartAjaxEnable) {
    CartJS.init(theme.cart, {
      dataAPI: true,
      moneyFormat: theme.moneyFormat,
    })
  }

  theme.Utils.embedResponsively($('[data-has-video-embeds]'))

})
